import { __ } from 'JIX/gettext.js';

export default {
    defaultLabel: () =>
        __('Sorter efter:'),
};
